import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'text-dialog',
	imports: [],
	templateUrl: './text-dialog.component.html',
	styleUrl: './text-dialog.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TextDialogComponent {
	constructor(
		@Inject(MAT_DIALOG_DATA)
		private data: {
			class: string;
			content: string;
		}[]
	) {}

	textDialogDataList: { class: string; content: string }[] = this.data;
}
